import { AssetUrls } from 'config/assets';
import { Message } from 'types/interfaces/message';

/**
 * System user constants
 */
export const SYSTEM_USERNAME = 'TradeMagic';

/**
 * The TradeMagic account's avatar when a system row carries none: the gold
 * logo the inbox list and the TradeMagic profile show. Rows normally carry the
 * account's own avatarUrl, which is what renders; this is the fallback only.
 */
export const TRADEMAGIC_AVATAR_URL = AssetUrls.logos.iconGold;

/**
 * Determines if a message is from the system
 * Only checks username to avoid conflicts with regular user IDs
 */
export const isSystemMessage = (message: Message): boolean => {
  return message.sender?.username === SYSTEM_USERNAME || message.sender === null;
};

/**
 * Determines if a conversation is with the system user
 * Used to conditionally hide reply functionality
 * Only checks username to avoid conflicts with regular user IDs
 */
export const isSystemConversation = (otherUserId: number, otherUsername: string): boolean => {
  return otherUsername === SYSTEM_USERNAME;
};
